function cleanUpTitleAttributes() {
  const anchors = document.querySelectorAll('.tmenu_item .tmenu_item_link');

  anchors.forEach((anchor) => {
    const titleText = anchor.getAttribute('title');
    if (!titleText) return;

    const tempElement = document.createElement('div');
    tempElement.innerHTML = titleText;
    tempElement.querySelectorAll('i').forEach((icon) => icon.remove());
    anchor.setAttribute('title', tempElement.textContent.trim());
  });
}

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      cleanUpTitleAttributes();
    }
  });
});

const observerConfig = {
  childList: true,
  subtree: true,
};

if (document.body) {
  observer.observe(document.body, observerConfig);
  cleanUpTitleAttributes();
}

